import React, {
  useState
} from "react";

import {
  MenuToggle,
  Select,
  SelectList,
  SelectOption
} from "@patternfly/react-core";


const EducationProfessionSelect = ({
  professions = [],
  selectedProfessionId,
  onProfessionChange
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!professions.length) {
    return null;
  }

  const selectedProfession =
    professions.find(
      profession =>
        profession.id === selectedProfessionId
    ) ?? null;

  const handleSelect = (
    _event,
    value
  ) => {
    onProfessionChange(value);
    setIsOpen(false);
  };

  const toggle = toggleRef => (
    <MenuToggle
        ref={toggleRef}
        isExpanded={isOpen}
        style={{
          minWidth: "12rem",
          paddingBlock:
            "var(--pf-t--global--spacer--xs)"
        }}
        onClick={() => {
        setIsOpen(previous => !previous);
        }}
        aria-label="Wybierz zawód"
    >
        {selectedProfession?.title ??
        "Wybierz zawód"}
    </MenuToggle>
    );

  return (
    <Select
        id="education-profession-select"
        isOpen={isOpen}
        selected={selectedProfessionId}
        onSelect={handleSelect}
        onOpenChange={setIsOpen}
        toggle={toggle}
        shouldFocusToggleOnSelect
    >
        <SelectList>
            {professions.map(profession => (
                <SelectOption
                key={profession.id}
                value={profession.id}
                >
                {profession.title}
                </SelectOption>
            ))}
        </SelectList>
    </Select>
    );
};


export default EducationProfessionSelect;